// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";

// App Imports
import Box from "@mui/material/Box";
import {changeExpense} from "../../WorkIssuanceExpense/expenseSlice";

import MoneyOffCsredIcon from '@mui/icons-material/MoneyOffCsred';
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function NonPayingExpense({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const handleNonPaying = () => {
        // dispatchData(changeExpense({rejectedState: true, expenseNewStatus: '2354'}));
        dispatchData(changeWorkIssuance({newStatus:  '2354', updateCdpStatus: true}));
        onMenuClose();
    };



    return (

        <Box>
            {(
                    // rowCdpStatus === "2351" ||  rowCdpStatus === "2359"
                    (rowCdpStatus !== "2359" && rowCdpStatus !== "3242" && rowCdpStatus !== "4553" && showExpense === true)
                ) &&
                <MenuItem onClick={handleNonPaying}>
                    <ListItemIcon>
                        <MoneyOffCsredIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Set as Non-Paying</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
